/* Hyperush — first-visit offer. One appearance per visitor, ever.
   Edit CONFIG below to change the code, copy or timing. */
(function () {
  'use strict';

  var CONFIG = {
    code: 'HYPE150',
    sticker: '₹150<br>OFF',
    kicker: 'First order',
    heading: 'Take ₹150 off your first one.',
    sub: 'New here? Use this at checkout. One per customer.',
    cta: 'Shop the drop',
    ctaHref: '/products/thumb-camera',
    dismiss: 'No thanks',
    copied: 'Copied',
    delayMs: 6000,
    scrollTrigger: 0.22,
    storageKey: 'hy-offer-v1'
  };

  function seen() {
    try { return localStorage.getItem(CONFIG.storageKey) === '1'; } catch (e) { return true; }
  }
  function remember() {
    try { localStorage.setItem(CONFIG.storageKey, '1'); } catch (e) {}
  }

  function build() {
    var root = document.createElement('div');
    root.className = 'hy-offer';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'First order offer');
    root.innerHTML =
      '<div class="hy-offer__scrim" data-hy-close></div>' +
      '<div class="hy-offer__card">' +
        '<div class="hy-offer__stripe" aria-hidden="true"></div>' +
        '<button class="hy-offer__x" type="button" aria-label="Close" data-hy-close>' +
          '<svg viewBox="0 0 16 16"><path d="M3 3l10 10M13 3L3 13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>' +
        '</button>' +
        '<span class="hy-offer__sticker hy-sticker hy-sticker--coral" aria-hidden="true">' +
          '<span class="hy-sticker__text">' + CONFIG.sticker + '</span>' +
        '</span>' +
        '<div class="hy-offer__body">' +
          '<span class="hy-offer__kicker">' + CONFIG.kicker + '</span>' +
          '<h2 class="hy-offer__h">' + CONFIG.heading + '</h2>' +
          '<p class="hy-offer__sub">' + CONFIG.sub + '</p>' +
          '<button class="hy-offer__code" type="button" data-hy-copy>' +
            '<span class="hy-offer__codetext">' + CONFIG.code + '</span>' +
            '<span class="hy-offer__copy">' +
              '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5.5" y="5.5" width="8" height="8" rx="1.4" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M10.5 3.5H3.2A.7.7 0 0 0 2.5 4.2v7.3" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>' +
            '</span>' +
          '</button>' +
          '<a class="hy-offer__cta" href="' + CONFIG.ctaHref + '">' +
            '<span>' + CONFIG.cta + '</span>' +
            '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 8h11M9 3.5 13.5 8 9 12.5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="square"/></svg>' +
          '</a>' +
          '<button class="hy-offer__no" type="button" data-hy-close>' + CONFIG.dismiss + '</button>' +
        '</div>' +
      '</div>';
    return root;
  }

  function open() {
    if (seen()) return;
    remember();

    var root = build();
    document.body.appendChild(root);
    document.documentElement.classList.add('hy-offer-open');

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { root.classList.add('is-in'); });
    });

    function close() {
      root.classList.remove('is-in');
      document.documentElement.classList.remove('hy-offer-open');
      window.setTimeout(function () {
        if (root.parentNode) root.parentNode.removeChild(root);
      }, 320);
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);

    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      if (e.target.closest('[data-hy-close]')) { close(); return; }

      var copyBtn = e.target.closest('[data-hy-copy]');
      if (copyBtn) {
        var done = function () {
          copyBtn.classList.add('is-copied');
          copyBtn.querySelector('.hy-offer__codetext').textContent = CONFIG.copied;
          window.setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            copyBtn.querySelector('.hy-offer__codetext').textContent = CONFIG.code;
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(CONFIG.code).then(done, done);
        } else {
          done();
        }
      }
    });
  }

  function arm() {
    if (seen()) return;
    if (/\/(cart|checkouts?|challenge|account)/.test(window.location.pathname)) return;

    var fired = false;
    var go = function () {
      if (fired) return;
      fired = true;
      window.removeEventListener('scroll', onScroll);
      open();
    };

    var timer = window.setTimeout(go, CONFIG.delayMs);

    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max > CONFIG.scrollTrigger) {
        window.clearTimeout(timer);
        go();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
